import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-marketplace-icons',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="icon-container" [class]="'icon-container ' + contextClass" [style.width]="size" [style.height]="size">
      <ng-container *ngIf="type === 'tokenworks'">
        <svg class="tokenworks-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 501 500">
          <rect x="1" y="1" width="500" height="498" fill="black"/>
          <path class="st1" d="M250,0C111.93,0,0,111.93,0,250s111.93,250,250,250,250-111.93,250-250S388.07,0,250,0ZM404.09,404.09c-29.15,29.16-73.79,29.16-154.09,29.16s-124.94,0-154.09-29.16c-29.16-29.16-29.16-73.79-29.16-154.09s0-124.94,29.16-154.09c29.16-29.15,73.79-29.15,154.09-29.15s124.94,0,154.09,29.15c29.16,29.16,29.16,73.79,29.16,154.09s0,124.94-29.16,154.09Z"/>
          <path class="st0" d="M239.22,203.73v-73.24h18.94v73.24h-18.94ZM211.53,132.4v-16.06h74.08v16.06h-74.08ZM301.44,203.73l-24.45-87.39h19.3l16.06,66.77h-1.56l16.9-66.77h18.1l16.66,66.77h-1.44l16.18-66.77h19.54l-24.93,87.39h-20.5l-15.35-61.26h1.68l-15.46,61.26h-20.74Z"/>
        </svg>
      </ng-container>

      <ng-container *ngIf="type === 'punkauction'">
        <div class="punk-auction-icon" [class]="'punk-auction-icon ' + contextClass">
          <img src="assets/punkauction.png" />
        </div>
      </ng-container>
    </div>
  `,
  styles: [`
    .icon-container {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .tokenworks-icon {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 0.5px solid black;
    }
    
    .tokenworks-icon {
      fill: #ffffff;
    }
    
    .punk-auction-icon {
      border: 0.5px solid #ff04b4;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 0.15rem;
      border-radius: 50%;
      background: rgba(var(--pink), 1);
      image-rendering: pixelated;
      overflow: hidden;
    }
    
    .punk-auction-icon img {
      width: 100%;
      height: 100%;
      transform: translateY(1px);
      object-fit: contain;
      object-position: bottom;
    }

    /* Dashboard specific styles */
    .icon-container.dashboard {
      transform: translateY(0.5rem);
      margin-left: 1.2rem;

      img {
        transform: translateY(2px);
      }
    }

    .punk-auction-icon.dashboard {
      padding: 0.3rem;
    }

    /* Tx-history specific styles */
    .icon-container.tx-history {
      margin-left: 1rem;
      transform: translateY(0.2rem);
      .punk-auction-icon {
        img {
          transform: scale(1.2) translateY(0px);
        }
      }
    }
    /* Grid view specific styles */
    .icon-container.grid-view {
      margin: 0;
      transform: none;

      .tokenworks-icon {
        transform: translateY(1.5px);
      }
    }

    /* Billboard specific styles */
    .icon-container.billboard {
      transform: none;
      margin: 0;
    }

    .punk-auction-icon.billboard {
      padding: 0.2rem;
    }

    .punk-auction-icon.billboard img {
      transform: translateY(1px);
    }

    /* Light theme support */
    :host-context(body[data-theme="light"]) .tokenworks-icon.dashboard {
      fill: black !important;
    }
  `]
})
export class MarketplaceIconsComponent {
  @Input() type!: 'tokenworks' | 'punkauction';
  @Input() size: string = '100%';
  @Input() contextClass: string = '';
}
